import React, { useState } from "react";
import { FetchResult } from "@apollo/client";

import Modal from "./message-modal";
import styles from "./modal.module.css";


export type Props = {
  action: () => Promise<FetchResult<any, Record<string, any>, Record<string, any>>>,
  buttonText: string,
  errorText?: string,
  removalText?: string,
  buttonColor?: "primary" | "secondary" | "tertiary" | "dangerous",
};

const DEFAULT_REMOVE_TEXT = "Are you sure you want to delete this item?";
const DEFAULT_ERROR_TEXT =
  "Unable to delete this item. Please try again or contact support@havenconnect.com.";
const DEFAULT_SECONDARY_MESSAGE = "This cannot be undone.";

export const RemoveModal: React.FC<Props> =
({ action, buttonText, buttonColor, removalText, errorText }) => {
  const [showModal, setShowModal] = useState(false);
  const [showError, setShowError] = useState(false);

  const showRemoveModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const closeErrorModal = () => setShowError(false);
  const setError = () => setShowError(true);

  const renderErrorModal = () => (
    <Modal
      isOpen={showError}
      onSubmit={closeErrorModal}
      onDismiss={closeErrorModal}
      message={errorText || DEFAULT_ERROR_TEXT}
      buttonColor="primary"
      buttonText="Dismiss"
    />
  );

  const handleSubmit = () => {
    action().then(
      () => null,
      setError,
    );
    closeModal();
  };

  const renderModal = () => (
    <Modal
      isOpen={showModal}
      onSubmit={handleSubmit}
      onDismiss={closeModal}
      message={removalText || DEFAULT_REMOVE_TEXT}
      secondaryMessage={DEFAULT_SECONDARY_MESSAGE}
      buttonColor={buttonColor || "dangerous"}
      buttonText={buttonText}
      cancelEnabled
    />
  );

  return (
    <span>
      <span onClick={showRemoveModal} className={styles.textLink}>{buttonText} </span>
      {renderErrorModal()}
      {renderModal()}
    </span>
  );
};
